<template>
  <div class="p-4 space-y-6 bg-n-background">
    <div class="space-y-2 animate-loader-pulse">
      <div class="h-6 bg-n-slate-4 dark:bg-n-slate-6 rounded w-1/5" />
      <div class="h-10 bg-n-slate-4 dark:bg-n-slate-6 rounded w-3/5" />
    </div>
    <div class="space-y-2 animate-loader-pulse">
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded w-4/5" />
    </div>
    <div class="space-y-2 animate-loader-pulse">
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded w-3/5" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
    </div>
    <div class="space-y-2 animate-loader-pulse">
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded" />
      <div class="h-5 bg-n-slate-4 dark:bg-n-slate-6 rounded w-3/5" />
    </div>
  </div>
</template>
